<script setup lang="ts">
import type { IFooterProfileLinkProps } from '@/widgets/LawyerCard/model/types/lawyerCard';

withDefaults(defineProps<IFooterProfileLinkProps>(), {
  isArticle: false,
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['footer-profile-link', { _article: isArticle }, { _mobile: isMobile }]">
    <AppButton
      class="footer-profile-link__button"
      :is-small="!isArticle"
      is-bordered
      is-white
      button-text="В профиль"
      right-icon-name="ArrowRight"
      right-icon-width="12"
      right-icon-height="12"
      :to="linkToProfileCatalog"
    />
  </div>
</template>

<style lang="less">
.footer-profile-link {
  display: flex;
  justify-content: flex-end;
  max-width: 285px;
  max-height: 45px;
  margin-left: auto;
  gap: @size-x5;

  &._article {
    max-width: 190px;
  }

  &._mobile {
    display: block;
  }
}
</style>
